import { format } from "date-fns";

// Date and time format strings for use with date-fns
// Starting with v2 format and parse uses Unicode tokens.
// https://date-fns.org/docs/format -> up to date formatting documentation
// https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
export const FORMAT_READABLE_WEEK_MONTH_TIME = "EEE MMM d HH:mm";

/**
 * returns info about the id_token and token_expiry in localStorage
 */
export function getTokenInfo(): {
  isTokenValid: boolean;
  isTokenExpiryInFuture: boolean;
  idToken: string | null;
  idTokenExpiryMs: number;
  idTokenExpFormatted: string | null;
  clearTokenFromLocalStorage: () => void;
  saveTokenInLocalStorage: (token: string, expiry: string | null) => void;
} {
  const idToken = window.localStorage.getItem("id_token");
  const idTokenExpiry = window.localStorage.getItem("token_expiry");
  const wasBadTokenCleared = window.localStorage.getItem("last_token_was_invalid");
  const idTokenExpiryMs = Number(idTokenExpiry);
  const isTokenExpiryInFuture = Boolean(idTokenExpiryMs && Date.now() < idTokenExpiryMs);
  const isTokenValid = Boolean(
    idToken &&
      isTokenExpiryInFuture &&
      // token is invalidated if we clear it using clearTokenFromLocalStorage
      !wasBadTokenCleared
  );
  const idTokenExpFormatted = idTokenExpiryMs
    ? format(idTokenExpiryMs, FORMAT_READABLE_WEEK_MONTH_TIME)
    : null;

  /** remove id_token and token_expiry, and set last_token_was_invalid to invalidate using the token from local storage */
  const clearTokenFromLocalStorage = () => {
    window.localStorage.removeItem("id_token");
    window.localStorage.removeItem("token_expiry");
    window.localStorage.setItem("last_token_was_invalid", "true");
  };

  /** save the new id_token in local storage and remove the last_token_was_invalid flag */
  const saveTokenInLocalStorage = (token: string, expiry: string | null) => {
    window.localStorage.setItem("id_token", token);
    window.localStorage.removeItem("last_token_was_invalid");
    if (expiry) {
      window.localStorage.setItem("token_expiry", expiry);
    }
  };

  return {
    isTokenValid,
    isTokenExpiryInFuture,
    idToken,
    idTokenExpiryMs,
    idTokenExpFormatted,
    clearTokenFromLocalStorage,
    saveTokenInLocalStorage,
  };
}

// function getUserFromDecodedToken(idTokenDecoded: IdToken | null) {
//   return (
//     idTokenDecoded &&
//     filterObjectByKeepingKeys(idTokenDecoded, [
//       "name",
//       "email",
//       "nickname",
//       "picture",
//       "email_verified",
//       "https://raven.ai/customer",
//       "https://raven.ai/app_metadata",
//       "updated_at",
//       "exp",
//     ])
//   );
// }
